import {Action} from '@ngrx/store';
import {AutoSked} from 'src/app/schedule/shared/model/autosked';
import {AutoSkedParams, ScheduleQueryParams} from 'src/app/schedule/shared/model/schedule-query-params';
import {SkedParams} from '../../model/sked-params';
import {Sked} from 'src/app/current-sked/shared/model/sked';
import {HttpErrorResponse} from '@angular/common/http';

export enum ScheduleActionType {
  UPDATE_QUERY_PARAMS = '[Schedule] Update Query Params',

  GET_AUTOSKEDS = '[Schedule] Get AutoSkeds',
  GET_AUTOSKEDS_SUCCESS = '[Schedule] Get AutoSkeds :: Success',

  GET_AUTOSKED = '[Schedule] Get AutoSked',
  GET_AUTOSKED_SUCCESS = '[Schedule] Get AutoSked :: Success',

  CREATE_AUTOSKED = '[Schedule] Create AutoSked',
  CREATE_AUTOSKED_SUCCESS = '[Schedule] Create AutoSked :: Success',

  UPDATE_AUTOSKED = '[Schedule] Update AutoSked',
  UPDATE_AUTOSKED_SUCCESS = '[Schedule] Update AutoSked :: Success',

  DELETE_AUTOSKED = '[Schedule] Delete AutoSked',
  DELETE_AUTOSKED_SUCCESS = '[Schedule] Delete AutoSked :: Success',

  TOGGLE_DEFAULT = '[Schedule] Toggle Default',
  TOGGLE_DEFAULT_SUCCESS = '[Schedule] Toggle Default :: Success',

  GET_SKEDS = '[Schedule] Get Skeds',
  GET_SKEDS_SUCCESS = '[Schedule] Get Skeds :: Success',

  UPDATE_SCHEDULE_TIMEZONE = '[Schedule] Update Schedule Timezone',

  UPDATE_SKEDS_WITH_NEW_TIMEZONE = '[Schedule] Update Skeds with New Timezone',

  CLEAR = '[Schedule] Clear',
}

export class UpdateScheduleQueryParams implements Action {
  public readonly type = ScheduleActionType.UPDATE_QUERY_PARAMS;

  public constructor(public payload: {params: ScheduleQueryParams}) {}
}

export class GetAutoSkeds implements Action {
  public readonly type = ScheduleActionType.GET_AUTOSKEDS;

  constructor(
    public payload: {
      params?: AutoSkedParams;
      onSuccess?: (autoSkeds: AutoSked[]) => void;
      onFailure?: () => void;
    }
  ) {}
}

export class GetAutoSkedsSuccess implements Action {
  public readonly type = ScheduleActionType.GET_AUTOSKEDS_SUCCESS;

  constructor(public payload: {autoSkeds: AutoSked[]}) {}
}

export class GetAutoSked implements Action {
  public readonly type = ScheduleActionType.GET_AUTOSKED;

  constructor(public payload: {autoSked: AutoSked; onSuccess?: (autoSked: AutoSked) => void}) {}
}

export class GetAutoSkedSuccess implements Action {
  public readonly type = ScheduleActionType.GET_AUTOSKED_SUCCESS;

  constructor(public payload: {autoSked: AutoSked}) {}
}

export class CreateAutoSked implements Action {
  public readonly type = ScheduleActionType.CREATE_AUTOSKED;

  constructor(public payload: {autoSked: AutoSked; onSuccess?: (autoSked: AutoSked) => void}) {}
}

export class CreateAutoSkedSuccess implements Action {
  public readonly type = ScheduleActionType.CREATE_AUTOSKED_SUCCESS;

  constructor(public payload: {autoSked: AutoSked}) {}
}

export class UpdateAutoSked implements Action {
  public readonly type = ScheduleActionType.UPDATE_AUTOSKED;

  constructor(
    public payload: {autoSked: AutoSked; onSuccess?: (autoSked: AutoSked) => void; onFailure?: (err: Error) => void}
  ) {}
}

export class UpdateAutoSkedSuccess implements Action {
  public readonly type = ScheduleActionType.UPDATE_AUTOSKED_SUCCESS;

  constructor(public payload: {autoSked: AutoSked}) {}
}

export class DeleteAutoSked implements Action {
  public readonly type = ScheduleActionType.DELETE_AUTOSKED;

  constructor(public payload: {autoSked: AutoSked; onSuccess?: (autoSked: AutoSked) => void}) {}
}

export class DeleteAutoSkedSuccess implements Action {
  public readonly type = ScheduleActionType.DELETE_AUTOSKED_SUCCESS;

  constructor(public payload: {autoSked: AutoSked}) {}
}

export class ToggleAutoSkedDefaultAction implements Action {
  public readonly type = ScheduleActionType.TOGGLE_DEFAULT;

  constructor(
    public payload: {
      skedState: string;
      userId?: string;
      teamId?: string;
      onSuccess?: () => void;
      onFailure?: (err: HttpErrorResponse) => void;
    }
  ) {}
}

export class ToggleAutoSkedDefaultSuccessAction implements Action {
  public readonly type = ScheduleActionType.TOGGLE_DEFAULT_SUCCESS;

  constructor(public payload: {autoSkeds: AutoSked[]}) {}
}

export class GetSkedsAction implements Action {
  public readonly type = ScheduleActionType.GET_SKEDS;

  constructor(public payload: {params: SkedParams; onSuccess?: () => void}) {}
}

export class GetSkedsSuccessAction implements Action {
  public readonly type = ScheduleActionType.GET_SKEDS_SUCCESS;

  constructor(public payload: {skeds: Sked[]}) {}
}

export class UpdateScheduleTimezoneAction implements Action {
  public readonly type = ScheduleActionType.UPDATE_SCHEDULE_TIMEZONE;

  constructor(public payload: {timezone: string}) {}
}

export class UpdateSkedsWithNewTimezoneAction implements Action {
  public readonly type = ScheduleActionType.UPDATE_SKEDS_WITH_NEW_TIMEZONE;

  constructor(
    public payload: {
      autoSkeds: AutoSked[];
      onSuccess?: (autoSkeds: AutoSked[]) => void;
      onFailure?: (err: Error) => void;
    }
  ) {}
}

export class ClearScheduleAction implements Action {
  public readonly type = ScheduleActionType.CLEAR;
}

export type ScheduleAction =
  | UpdateScheduleQueryParams
  | GetAutoSkeds
  | GetAutoSkedsSuccess
  | GetAutoSked
  | GetAutoSkedSuccess
  | CreateAutoSked
  | CreateAutoSkedSuccess
  | UpdateAutoSked
  | UpdateAutoSkedSuccess
  | DeleteAutoSked
  | DeleteAutoSkedSuccess
  | ToggleAutoSkedDefaultAction
  | ToggleAutoSkedDefaultSuccessAction
  | GetSkedsAction
  | GetSkedsSuccessAction
  | UpdateScheduleTimezoneAction
  | UpdateSkedsWithNewTimezoneAction
  | ClearScheduleAction;
